module.exports = __webpack_public_path__ + "static/media/map-signs.9662fdf7.svg";